<div>
	<div class="modal-header">
		<h4 class="modal-title">Réinitialiser son mot de passe</h4>
		<button type="button" class="close" aria-label="Close" (click)="cancelDialog()"><span aria-hidden="true">&times;</span></button>
	</div>

	<div class="modal-body">
		<form [formGroup]="passwordForm">
			<div class="form-group">
				<label for="username" class="ls-label-strong">Votre identifiant</label>
				<input required #userName id="username" type="text" class="form-control" formControlName="userNameControl" placeholder="Saisissez votre identifiant" ngbAutofocus>
				<p>
					<br>
					<i>
					Un email vous sera envoyé avec un mot de passe temporaire.
					</i>
				</p>
			</div>
		</form>
	</div>

	<div class="modal-footer">
		<button matTooltip="Annuler" mat-raised-button type="button" class="btn btn-light" (click)="cancelDialog()">Annuler</button>
		<button matTooltip="Réinitialiser le mot de passe" mat-raised-button type="submit" class="btn btn-primary" [disabled]="!enableAction || !passwordForm.valid" (click)="resetPassword()">{{buttonText}}</button>
	</div>
</div>
